const brightYellow500Color = '#F3CA00';

export default brightYellow500Color;
